enum VerticalDirectionEnum {
  Up = 'UP',
  Down = 'DOWN',
}

export default VerticalDirectionEnum;
